module.exports = __webpack_public_path__ + "static/img/dentaltalk_lg_landscape.26021cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/dentaltalk_lg_landscape.png
// module id = OVwT
// module chunks = 1